import { withState } from "@mna/react";
import create from "assets/img/Create_img.png";
import { Trans } from "react-i18next";
import LoadingScreen from "./LoadingScreen";

const UserCreatedSuccessFully = ({ state, actions, history }) => (
	<div className="page-section-2">
		<div className="container-2 w-container">
			<LoadingScreen isLoading={state.isLoading}>
				<div className="w-row">
					<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
					<div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
						<div>
							<h3>
								<Trans i18nKey="userregistration.confirmation">Account has been set up, you can now proceed to triaging yourself to
									better care
								</Trans>
							</h3>
							<div className="continue-btn">
								<button
									type="button"
									className="button1 btn standby-button-gradient standby-button-gradient-blue"
									onClick={(e) => {
										e.preventDefault();
										actions.startAzureLogin()
									}}
								>
									<Trans i18nKey="findcareoption.Careoptions.Concierge.Done">
										DONE
									</Trans>
								</button>
							</div>
						</div>
					</div>
					<div className="w-col w-col-6 w-col-tiny-tiny-stack">
						<img src={create} className="t-img" />
					</div>
				</div>
			</LoadingScreen>
		</div>
	</div>
);

export default withState({
	didMount({ state, actions, setState }) { },
})(UserCreatedSuccessFully);
